import axios from 'axios'
import {getUserToken} from '../../../functions.js'
import {getCloudFunctionBase} from '../../../config/deployment'

// const fileUrl = "http://localhost:8080"

let envUri = getCloudFunctionBase()
let fileUrl = envUri+'/cf-file-repository';
const privateFilesURL = `${envUri}/cf-user-private-files`;

export const uploadUserFiles=(formData)=>{
    return new Promise((resolve, reject) =>{
        getUserToken()
            .then(token => {
                var url = fileUrl+"?token="+token
                axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}} )
                    .then(resp => {
                        resolve(resp.data)
                    })
                    .catch(err => {
                        reject(err)
                    });
            })
            .catch(err => {
                reject(err)
            })
    })
};

export const uploadUserPrivateFiles = async (formData) => {
    const token = await getUserToken();
    const response = await axios.post(privateFilesURL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { token },
    });

    return response.data;
};

export const downloadUserFile = (filename) =>{
    return new Promise((resolve, reject) => {
        getUserToken()
            .then(token => {
                var params = {token: token, filename: filename}
                axios({
                    url: fileUrl,
                    method: 'GET',
                    params: params,
                    responseType: 'blob', // important
                })
                    .then((resp) => {
                        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        resolve()
                    })      
                    .catch(err => {
                        if(err.response && err.response.status == 404) reject("No such file found")
                        else reject("Cannot get file")
                    })
            })
            .catch(err => {
                console.log("downloadUserFile | > catch | err:", err)
                reject("Cannot get file")
            })
    })
};

export const downloadUserPrivateFile = async (filename) => {
    const token = await getUserToken();
    const response = await axios.get(privateFilesURL, {
        params: { token: token, filename: filename },
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); //or any other extension
    document.body.appendChild(link);
    link.click();
};

export const getFileIcon=(filename)=>{
    return FILE_TYPES_TO_ICONS[getFileExtension(filename)]
}
function getFileExtension(filename){
    return filename.substring(filename.lastIndexOf('.')+1)
}

export const allowedFileMimeType=(file)=>{
    return AVAILABLE_MIME_TYPES[file.type]
}

const FILE_TYPES_TO_ICONS={
    "txt": "text_fields",
    "pdf": "picture_as_pdf",
    "jpg": "collections",
    "jpeg": "collections",
    "png": "collections",
    "xls": "table_chart",
    "xlsx": "table_chart",
    "doc": "file_copy",
    "docx": "file_copy",
    "zip": "folder_open"
}

const AVAILABLE_MIME_TYPES = {
    "txt": "text/plain",
    "pdf": "application/pdf",
    "jpg": "image/jpeg",
    "jpeg": "image/jpeg",
    "png": "image/png",
    "xls": "application/vnd.ms-excel",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "doc": "application/msword",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "zip": "application/zip",
    /*
    * .asice, .sce, etc:
    * 1. https://en.wikipedia.org/wiki/Associated_Signature_Containers
    * 2. https://www.etsi.org/deliver/etsi_ts/102900_102999/102918/01.01.01_60/ts_102918v010101p.pdf
    * */
    "asice": "application/vnd.etsi.asic-e+zip",
    "sce": "application/vnd.etsi.asic-e+zip",
    "asics": "application/vnd.etsi.asic-s+zip",
    "scs": "application/vnd.etsi.asic-s+zip",
    "text/plain": true,
    "application/pdf": true,
    "image/jpeg": true,
    "image/png": true,
    "application/vnd.ms-excel": true,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
    "application/msword": true,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
    "application/zip": true,
}


// WEBPACK FOOTER //
// ./src/platform/files/services/fileService.js